import { createFileRoute, redirect } from '@tanstack/react-router';

/** Moved into the Contacts hub as the "Labels" tab. Redirect keeps old links
 *  and bookmarks working. */
export const Route = createFileRoute('/vendor/labels')({
  beforeLoad: () => {
    throw redirect({ to: '/vendor/contacts', search: { tab: 'labels' } });
  },
});
